import * as Cookies from 'js-cookie'

const getIsFromCapacitorBrowser = () => {
  if (typeof window === 'undefined') return false
  const urlParams = new URLSearchParams(window.location.search)
  const hasQueryString = urlParams.get('origin') === 'capacitor'

  const cookie = Cookies.get('is_from_capacitor_browser')
  const hasCookie = cookie === 'true'

  return hasQueryString || hasCookie
}

export const isFromCapacitorBrowser = getIsFromCapacitorBrowser()
